export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY
export const GOOGLE_MAP_STYLE =
  import.meta.env.VITE_GOOGLE_MAP_STYLE && JSON.parse(import.meta.env.VITE_GOOGLE_MAP_STYLE)
export const FIREBASE_ENV = import.meta.env.VITE_FIREBASE_ENV
export const FIREBASE_CONFIG = import.meta.env.VITE_FIREBASE_CONFIG && JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG)
export const FTL_WEB_APP = import.meta.env.VITE_FTL_WEB_APP
export const FTL_WEB_APP_API = import.meta.env.VITE_API_WEBAPP_URL
export const WEBAPP_PRICING_API = import.meta.env.VITE_WEBAPP_PRICING
export const FTL_WEB_APP_PH = import.meta.env.VITE_FTL_WEB_APP_PH
export const API_FTL_AUTH_URL = import.meta.env.VITE_API_FTL_AUTH_URL
export const API_FTL_CREDIT_ACCOUNT_URL = import.meta.env.VITE_API_FTL_CREDIT_ACCOUNT_URL
export const API_LCL_URL = import.meta.env.VITE_API_LCL_URL
export const FTL_HUB = import.meta.env.VITE_FTL_HUB
export const FTL_HUB_PH = import.meta.env.VITE_FTL_HUB_PH
export const TWILIO_PREFIX = import.meta.env.VITE_TWILIO_PREFIX
export const WEBAPP_ASSET = import.meta.env.VITE_WEBAPP_ASSET
export const GOOGLE_TAG_MANAGER_CODE = import.meta.env.VITE_GOOGLE_TAG_MANAGER_CODE
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
export const MOENGAGE_APP_ID = import.meta.env.VITE_MOENGAGE_APP_ID
export const DEBUG_LOGS_MOENGAG = import.meta.env.VITE_DEBUG_LOGS_MOENGAGE
// export const FIREBASE_WEB_PUSH_KEY = import.meta.env.VITE_FIREBASE_WEB_PUSH_KEY
export const JAKARTA_AREA = import.meta.env.VITE_JAKARTA_AREA

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_KEY
export const FACEBOOK_CLIENT_ID = import.meta.env.VITE_FACEBOOK_ID

// sentry
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV

export const GOOGLE_RECAPTCHA_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY
